import { axios } from "@/plugins/http-request.js";

const actions = {
  getchannelMapping(context, payload) {
    return axios
      .get(
        `/api/fulfillment/client_channel_list?client_id=${payload.client_id}`
      )
      .then((res) => res.data);
  },
  syncMapping() {
    return axios.get(`/api/fulfillment/storer_sync`).then((res) => res.data);
  },
  getclientChannelList() {
    return axios.get(`/api/fulfillment/channel_list`).then((res) => res.data);
  },
  createClientMapping(context, payload) {
    return axios
      .post("/api/fulfillment/client_channel_mapping", payload.params)
      .then((res) => res.data);
  },
  updatechannelMapping(context, payload) {
    return axios
      .patch(
        `/api/fulfillment/channel-client-mapping-change-status/${payload.id}`
      )
      .then((res) => res.data);
  },
  checkClientMapping(context, payload) {
    return axios
      .post("/api/fulfillment/channel_check", payload.params)
      .then((res) => res.data);
  },
};

export default {
  actions,
};
